import * as actionTypes from 'modules/payments/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

const initialState = false;

const isOpen = () => true;

const isClose = () => false;

export default createReducer(initialState, {
  [actionTypes.OPEN_EXPORT_PAYMENT_MODAL]: isOpen,
  [actionTypes.CLOSE_EXPORT_PAYMENT_MODAL]: isClose,
  [actionTypes.EXPORT_PAYMENT_SUCCESS]: isClose,
  [actionTypes.EXPORT_PAYMENT_FAILURE]: isClose,
});
